import React from 'react';

export function IconQuickstart({ width = 25, height = 25, ...props }: React.SVGProps<SVGSVGElement>) {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        width={width}
        height={height}
        fill="none"
        {...props}
    >
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 17c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91A2.18 2.18 0 0 0 5 17ZM12.5 15.5l-3-3a21.996 21.996 0 0 1 2-3.95 12.88 12.88 0 0 1 11-6.05c0 2.72-.78 7.5-6 11a22.355 22.355 0 0 1-4 2Z"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9.5 12.5h-5s.55-3.03 2-4c1.62-1.08 5 0 5 0M12.5 15.5v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"
        />
    </svg>;
}
